import { useEffect, useState } from 'react';

type Props = { botUsername?: string };

/**
 * Landing shown when the app is opened in a regular browser, outside the
 * Telegram WebApp bridge (BogStars.md: "вход по домену из браузера, там
 * надо редирект на тг бота заглушку"). Anyone who slips in here counts as
 * 'anon' and gets a button to bounce into the actual bot.
 *
 * Dev override: append ?dev=1 to the URL to bypass — handy for Playwright,
 * Vite previews, and local dev without spinning up Telegram.
 */
export function BrowserStub({ botUsername: botUsernameProp }: Props) {
    const [paid, setPaid] = useState<{ count: number; total: number } | null>(null);
    const [botUsername, setBotUsername] = useState<string>(
        botUsernameProp && botUsernameProp.trim() ? botUsernameProp : 'BogStarsBot',
    );

    useEffect(() => {
        fetch('/api/withdrawals/feed')
            .then((r) => r.ok ? r.json() : Promise.reject())
            .then((j: { items: Array<{ amount: number }> }) => {
                const total = j.items.reduce((s, w) => s + (w.amount || 0), 0);
                setPaid({ count: j.items.length, total });
            })
            .catch(() => setPaid(null));

        // Best-effort bot handle lookup so the deeplink resolves to the live
        // bot even when the caller didn't pass one down.
        fetch('/api/settings/public')
            .then((r) => r.ok ? r.json() : Promise.reject())
            .then((j: { botUsername?: string }) => {
                if (j.botUsername && j.botUsername.trim()) setBotUsername(j.botUsername);
            })
            .catch(() => { /* keep default */ });
    }, []);

    const botLink = `https://t.me/${botUsername}`;

    return (
        <div className="view view-center browser-stub">
            <h1 className="logo" style={{ marginTop: 24 }}>BOGSTARS</h1>
            <p style={{ textAlign: 'center', color: 'var(--muted)', maxWidth: 320 }}>
                Этот сайт работает только внутри Telegram-бота.
                Перейдите в бота, чтобы получить BSP, играть в Battles,
                Boxes и забирать выводы.
            </p>

            {paid && paid.count > 0 && (
                <div className="stats-box" style={{ marginTop: 12 }}>
                    <div className="stat-row">
                        <span>💸 Последних выводов:</span>
                        <span className="stat-value">{paid.count}</span>
                    </div>
                    <div className="stat-row">
                        <span>📊 Сумма за период:</span>
                        <span className="stat-value">
                            {paid.total.toLocaleString('ru-RU')} BSP
                        </span>
                    </div>
                </div>
            )}

            <a
                className="giveaway-btn"
                href={botLink}
                style={{ marginTop: 16, textDecoration: 'none' }}
            >
                <span className="giveaway-btn-title">ОТКРЫТЬ БОТА</span>
                <span className="menu-timer">@{botUsername}</span>
            </a>

            <p style={{
                marginTop: 24, fontSize: 11, color: 'var(--muted)',
                textAlign: 'center', maxWidth: 320,
            }}>
                Если бот уже открыт — обновите его в Telegram.
                Авторизация работает только через Telegram WebApp.
            </p>
        </div>
    );
}
